/*
 * `DES-001`. Page frame, hints and errors moved to the shared
 * `customer/CustomerPage.module.css` — this screen's `max-width` was 32rem
 * while its two siblings were 48rem, so the `<h1>` jumped sideways whenever
 * you moved between them.
 */

/*
 * The form had no gap at all: measured 0px between every pair of fields, so
 * each label sat flush against the input above it and read as a caption for
 * the wrong control.
 */
.form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 28rem;
}

.caveat {
  color: var(--ink-soft);
  font-size: var(--text-min-mono);
  border-left: 2px solid var(--warn);
  padding-left: 0.75rem;
  margin: 0;
}
